import { css } from '@emotion/react';
import { Styles, theme, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Variants } from 'motion/react';

export type BadgeColor = 'gray' | 'success' | 'info' | 'highlight' | 'highlight-bg' | 'match-rate';

export const badgeVerifiedVariants: Variants = {
  initial: {
    backgroundColor: theme.colors.primary.fuchsia[40],
  },
  animate: {
    backgroundColor: theme.colors.primary.fuchsia[10],
    transition: {
      duration: 0.44,
      delay: 2,
      ease: [0.22, 0.9, 0.53, 1],
    },
  },
};

const styles = {
  badge: css`
    display: flex;
    align-items: center;
    border-radius: 11px;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
  `,
  size: {
    medium: css`
      gap: 4px;
      height: 18px;
      padding: 1px 5.5px 0;
    `,
    large: css`
      gap: 6px;
      height: 22px;
      padding: 0 8px 0 4px;
    `,
  },
  color: {
    gray: ({ theme }) => css`
      background-color: ${theme.colors.neutral.variant[10]};
      color: ${theme.colors.neutral.variant[80]};
    `,
    success: ({ theme }) => css`
      background-color: ${theme.colors.secondary.emerald[10]};
      color: ${theme.colors.secondary.emerald[60]};
    `,
    info: ({ theme }) => css`
      background-color: ${theme.colors.secondary.sky[10]};
      color: ${theme.colors.secondary.sky[50]};
    `,
    highlight: ({ theme }) => css`
      background-color: ${theme.colors.primary.fuchsia[10]};
      color: ${theme.colors.neutral.variant[80]};
    `,
    'highlight-bg': ({ theme }) => css`
      background-color: ${theme.colors.primary.fuchsia[40]};
      color: ${theme.colors.neutral.variant[0]};
    `,
    'match-rate': ({ theme }) => css`
      background-color: white;
      color: ${theme.colors.primary.fuchsia[50]};
      border: 1px solid ${theme.colors.primary.fuchsia[50]};
      text-transform: none;
    `,
  },
} satisfies Styles<void, { color: BadgeColor; size: 'medium' | 'large' }>;

export const useStyles = withStyles(styles);
